import { useCallback, useState } from 'react';

/**
 * This hook allows us to "force" an update to a component by trigerring a hidden state update.
 * Execute the returned function to cause the state update.
 */
const useForceUpdate = () => {
  const [, setTick] = useState(0);
  const update = useCallback(() => setTick((tick) => tick + 1), []);

  return update;
};

export default useForceUpdate;
